var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { List as AntdList } from "antd";
export var List = function (props) {
    return _jsx(AntdList, __assign({}, props));
};
export var ListItem = function (props) { return _jsx(AntdList.Item, __assign({}, props)); };
export var ListItemMeta = function (props) { return _jsx(AntdList.Item.Meta, __assign({}, props)); };
